<template>
  <div>
    <means>
      <div slot="title">比价规避方法</div>
      <strong slot="tips">方法一:分享到微信延迟1小时购买</strong>
      <div slot="imgOne">
        <img src="../../static/instructions/mean-link.jpeg" alt="" />
      </div>
      <div slot="tipsOne">第一步<br />在拼多多复制商品链接</div>
      <div slot="imgTwo">
        <img src="../../static/instructions/openqss.jpg" alt="" />
      </div>
      <span slot="tipsTwo">第二步<br />打开钱收收</span>

      <div slot="imgThree">
        <img src="../../static/instructions/mean-collectMoney.jpeg" alt="" />
      </div>
      <span slot="tipsThree">第三步<br />点击“分享收钱”</span>
      <div slot="imgFour">
        <img src="../../static/instructions/mean-Copywriting.jpeg" alt="" />
      </div>
      <span slot="tipsFour"
        >第四步<br />复制“分享文案”给“文件<br />传输助手”</span
      >
      <div slot="imgFive">
        <img src="../../static/instructions/mean-friend.jpg" alt="" />
      </div>
      <span slot="tipsFive">第五步<br />延迟1小时下单可正常<br />拿到返利</span>
    </means>
  </div>
</template>

<script>
import Means from "./means.vue";
export default {
  components: {
    Means
  }
};
</script>

<style lang="less" scoped></style>
